"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfiniteGalleriesLoading = void 0;
const utils_1 = require("../utils");
const useInfiniteLoading_1 = require("./useInfiniteLoading");
async function fetchGalleries(page, pageSize) {
    const result = await fetch((0, utils_1.getResolvedPath)('/api/fetch-galleries'), {
        method: 'POST',
        headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            page,
            pageSize,
        }),
    });
    if (!result.ok) {
        const { message } = await result.json();
        throw new Error(message);
    }
    return result.json();
}
/**
 * NOTE: This hook depends on the presence of a Next API route (/api/fetch-galleries)!
 * The handler for this route is exported from `apiHandlers/fetchGalleries.ts` file.
 * See https://github.com/prezly/theme-nextjs-bea/blob/d381e9878187ca98815d240d3ffdf10a75993c14/pages/media/index.tsx#L23 for usage example
 */
function useInfiniteGalleriesLoading(initialGalleries, pagination) {
    const { canLoadMore, data, isLoading, loadMore } = (0, useInfiniteLoading_1.useInfiniteLoading)({
        fetchingFn: async (nextPage, pageSize) => {
            const { galleries } = await fetchGalleries(nextPage, pageSize);
            return galleries;
        },
        initialData: initialGalleries,
        pagination,
    });
    return {
        canLoadMore,
        galleries: data,
        isLoading,
        loadMoreGalleries: loadMore,
    };
}
exports.useInfiniteGalleriesLoading = useInfiniteGalleriesLoading;
//# sourceMappingURL=useInfiniteGalleriesLoading.js.map